import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { api } from '../../api';
import './Admin.css';

export default function AdminQuickLinks() {
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState({ type: '', text: '' });
  const [adding, setAdding] = useState(false);
  const [editing, setEditing] = useState(null);
  const [form, setForm] = useState({ label: '', url: '', sort_order: 0, is_active: 1 });

  const load = () => {
    setLoading(true);
    api.get('/api/quick_links.php')
      .then((data) => { setList(Array.isArray(data) ? data : []); setMessage({ type: '', text: '' }); })
      .catch(() => setList([]))
      .finally(() => setLoading(false));
  };

  useEffect(() => { load(); }, []);

  const openAdd = () => {
    setEditing(null);
    setAdding(true);
    setForm({ label: '', url: '', sort_order: list.length, is_active: 1 });
  };

  const openEdit = (row) => {
    setAdding(false);
    setEditing(row.id);
    setForm({ label: row.label || '', url: row.url || '', sort_order: row.sort_order ?? 0, is_active: row.is_active ?? 1 });
  };

  const save = async (e) => {
    e.preventDefault();
    setMessage({ type: '', text: '' });
    try {
      if (editing) {
        await api.put(`/api/quick_link.php?id=${editing}`, form);
        setMessage({ type: 'success', text: 'Quick link updated.' });
      } else {
        await api.post('/api/quick_links.php', form);
        setMessage({ type: 'success', text: 'Quick link created.' });
      }
      setEditing(null);
      setAdding(false);
      load();
    } catch (err) {
      setMessage({ type: 'error', text: err.error || 'Save failed' });
    }
  };

  const remove = async (id) => {
    if (!window.confirm('Remove this quick link?')) return;
    try {
      await api.delete(`/api/quick_link.php?id=${id}`);
      setMessage({ type: 'success', text: 'Quick link removed.' });
      load();
    } catch (err) {
      setMessage({ type: 'error', text: err.error || 'Delete failed' });
    }
  };

  const closeForm = () => {
    setEditing(null);
    setAdding(false);
    setForm({ label: '', url: '', sort_order: 0, is_active: 1 });
  };

  return (
    <div className="admin-section">
      <h1>Quick links</h1>
      <p style={{ color: '#666', fontSize: '0.9rem', marginBottom: '1rem' }}>These appear in the sidebar. Only active links are shown on the public site.</p>
      {message.text && <div className={`admin-message ${message.type}`}>{message.text}</div>}
      <div className="admin-toolbar">
        <button type="button" className="admin-btn admin-btn-primary" onClick={openAdd}>Add quick link</button>
      </div>
      {(editing !== null || adding) && (
        <div className="admin-form">
          <h2>{editing ? 'Edit quick link' : 'New quick link'}</h2>
          <form onSubmit={save}>
            <label>Label *</label>
            <input value={form.label} onChange={(e) => setForm({ ...form, label: e.target.value })} required />
            <label>URL *</label>
            <input value={form.url} onChange={(e) => setForm({ ...form, url: e.target.value })} required placeholder="/contact or /category/kb/123" />
            <p style={{ fontSize: '0.85rem', color: '#666', marginTop: '0.25rem' }}>Use internal paths (e.g. /contact, /category/kb/123) for client-side navigation.</p>
            <div className="row">
              <div><label>Sort order</label><input type="number" value={form.sort_order} onChange={(e) => setForm({ ...form, sort_order: parseInt(e.target.value, 10) || 0 })} /></div>
              <div><label>Active</label><select value={form.is_active} onChange={(e) => setForm({ ...form, is_active: parseInt(e.target.value, 10) })}><option value={1}>Yes</option><option value={0}>No</option></select></div>
            </div>
            <div className="admin-form-actions">
              <button type="submit" className="admin-btn admin-btn-primary">Save</button>
              <button type="button" className="admin-btn admin-btn-secondary" onClick={closeForm}>Cancel</button>
            </div>
          </form>
        </div>
      )}
      <div className="admin-table-wrap">
        {loading ? <p style={{ padding: '1rem' }}>Loading…</p> : (
          <table className="admin-table">
            <thead>
              <tr>
                <th>Order</th>
                <th>Label</th>
                <th>URL</th>
                <th>Active</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {list.map((row) => (
                <tr key={row.id}>
                  <td>{row.sort_order}</td>
                  <td>{row.label}</td>
                  <td>
                    {(row.url || '').startsWith('/') ? (
                      <Link to={row.url} style={{ fontSize: '0.85rem' }}>{(row.url || '').slice(0, 50)}{(row.url || '').length > 50 ? '…' : ''}</Link>
                    ) : (
                      <a href={row.url} target="_blank" rel="noopener noreferrer" style={{ fontSize: '0.85rem' }}>{(row.url || '').slice(0, 50)}…</a>
                    )}
                  </td>
                  <td>{row.is_active ? 'Yes' : 'No'}</td>
                  <td>
                    <button type="button" className="admin-btn admin-btn-secondary admin-btn-small" onClick={() => openEdit(row)}>Edit</button>
                    <button type="button" className="admin-btn admin-btn-danger admin-btn-small" onClick={() => remove(row.id)}>Delete</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
        {!loading && list.length === 0 && <p style={{ padding: '1rem' }}>No quick links. Add one to show in the sidebar.</p>}
      </div>
    </div>
  );
}
